import { StandardTextFieldProps } from '@mui/material/TextField'
import * as S from './styles'

interface ITextFieldProps extends StandardTextFieldProps {}

const TextFieldComponent = (props: ITextFieldProps) => {
  return <S.TextFieldComponent fullWidth {...props} />
}

export { TextFieldComponent }
export type { ITextFieldProps }
